const flyersState = {
  list: {},
  related: {},
  stores: {},
}

export default flyersState
